export default "__VITE_ASSET__SFD1gimB__"